export const EVENTS = {
  MEETING_SHARED: 'meeting_shared',
  MEETING_UNSHARED: 'meeting_unshared',
  MEETING_INVITED: 'meeting_invited',
  MEETING_UNINVITED: 'meeting_uninvited',
  AGENT_TEMPLATE_CREATED: 'agent_template_created',
  AGENT_TEMPLATE_EDITED: 'agent_template_edited',
  CHAT_MESSAGE_RECEIVED: 'chat_message_received',
  CHAT_THREAD_GENERATED: 'chat_thread_generated',
  CHAT_MESSAGE_SENT: 'chat_message_sent',
  ADD_TO_AGENDA_CLICKED: 'add_to_agenda_clicked',
  ADD_TO_AGENDA_SENT: 'add_to_agenda_sent',
  DELEGATE_TASK_CLICKED: 'delegate_task_clicked',
  DELEGATE_TASK_SENT: 'delegate_task_sent',
  QUICK_ACTION_CLICKED_DISMISSED: 'quick_action_clicked_dismissed',
  QUICK_ACTION_CLICKED_APPROVED: 'quick_action_clicked_approved',
  TASK_MARKED_DONE: 'task_marked_done',
  TASK_DISMISSED: 'task_dismissed',
  MEETING_BOT_SCHEDULED: 'bot_invited_calendar',
  MEETING_BOT_INVITED_ON_DEMAND: 'bot_invited_on_demand',
  GOAL_CREATED: 'goal_created',
  GOAL_EDITED: 'goal_edited',
  PLAN_GENERATED: 'plan_generated',
  PLAN_REGENERATED: 'plan_regenerated',
  PLAN_EDITED: 'plan_edited',
  POPUP_WINDOW_ERROR: 'popup_window_error'
};
